(() => {
  const root = document.querySelector('.delulu-header-search');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const form = root.querySelector('form');
  const input = root.querySelector('input[name="q"]');
  const reset = root.querySelector('.delulu-header-search__reset');
  const starter = root.querySelector('[data-delulu-search-starter]');
  const recentWrap = root.querySelector('[data-delulu-recent-wrap]');
  const recentList = root.querySelector('[data-delulu-recent-list]');
  if (!form || !input || !reset) return;

  const RECENT_KEY = 'delulu-recent-searches';
  const RECENT_MAX = 5;

  const getRecent = () => {
    try {
      const raw = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter((t) => typeof t === 'string') : [];
    } catch (_) {
      return [];
    }
  };

  const saveRecent = (term) => {
    const clean = term.trim();
    if (clean === '') return;
    try {
      const next = [clean, ...getRecent().filter((t) => t.toLowerCase() !== clean.toLowerCase())];
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(next.slice(0, RECENT_MAX)));
    } catch (_) {
      /* storage unavailable: search still works */
    }
  };

  const renderRecent = () => {
    if (!recentWrap || !recentList) return;
    const terms = getRecent();
    recentList.innerHTML = '';
    if (terms.length === 0) {
      recentWrap.hidden = true;
      return;
    }
    terms.forEach((term) => {
      const li = document.createElement('li');
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = term;
      button.addEventListener('click', () => {
        input.value = term;
        syncReset();
        hideStarter();
        form.requestSubmit();
      });
      li.appendChild(button);
      recentList.appendChild(li);
    });
    recentWrap.hidden = false;
  };

  const showStarter = () => {
    if (!starter || input.value.trim() !== '') return;
    renderRecent();
    starter.hidden = !recentWrap || recentWrap.hidden;
  };

  const hideStarter = () => {
    if (starter) starter.hidden = true;
  };

  const syncReset = () => {
    reset.classList.toggle('hidden', input.value.length === 0);
  };

  input.addEventListener('input', () => {
    syncReset();
    hideStarter();
  });
  input.addEventListener('focus', showStarter);
  input.addEventListener('click', showStarter);
  syncReset();

  reset.addEventListener('click', () => {
    input.value = '';
    syncReset();
    input.focus();
    showStarter();
  });

  form.addEventListener('submit', (event) => {
    const term = input.value.trim();
    if (term === '') {
      event.preventDefault();
      return;
    }
    saveRecent(term);
    hideStarter();
  });

  document.addEventListener('pointerdown', (event) => {
    if (!root.contains(event.target)) hideStarter();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (document.activeElement === input) input.blur();
      hideStarter();
    }
  });
})();
